import { render, staticRenderFns } from "./OrderReviewHeader.vue?vue&type=template&id=44daedec&scoped=true&"
import script from "./OrderReviewHeader.vue?vue&type=script&lang=js&"
export * from "./OrderReviewHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44daedec",
  null
  
)

export default component.exports